import React, { useEffect, useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { Button, Modal, Table, Spinner, Alert, Badge } from 'react-bootstrap';
import { DataManager } from '../../../core/data-manager';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ModalEntityViewer from '../../../components/Modals/ModalEntityViewer';
import ModalList from '../../../components/Modals/ModalList';
import { Utils } from '../../../core/utils';
import { ViewManager } from '../../../core/view-manager';



export default function DGLTH_item_model_quantity({ item, entity = null }) {

    const navigate = useNavigate();

    const [statusModalEntityViewerMovimenti, setStatusModalEntityViewerMovimenti] = useState(false);
    const [searchObjMovimenti, setSearchObjMovimenti] = useState(null);
    const searchableFields = Utils.cloneObject(ViewManager.getSearchableColumns('item_model_movement'));


    function closeModalEntityViewerMovimenti() {
        setStatusModalEntityViewerMovimenti(false)
    }

    function openModalEntityViewerMovimenti() {
        var c = [{ fieldName: "idItemModel", type: "value", value: item.idItemModel }];
        if (item.idWarehouse) {
            c.push({ fieldName: "idWarehouse", type: "value", value: item.idWarehouse })
        }
        setSearchObjMovimenti({
            'query': '',
            'fields': searchableFields,
            'constraints': c        
        })
        setStatusModalEntityViewerMovimenti(true)
    }


    function loadUnload() {
        console.log(item)
        var link = '/page/Warehouse?id=' + item.idItemModel;
        if (item.idWarehouse) {
            link = link + '&m=' + item.idWarehouse
        }
        console.log(link)
        navigate(link);
    }




    return (
        <>
            <Button size={'sm'} variant='primary' onClick={() => loadUnload()} className='me-1'>C/S</Button>
            <Button size={'sm'} variant='outline-success' className='me-1' onClick={() => openModalEntityViewerMovimenti()}>Storico movimenti</Button>
            {statusModalEntityViewerMovimenti !== false && (
                <ModalList entity={'item_model_movement'} searchObj={searchObjMovimenti} closeModal={closeModalEntityViewerMovimenti} status={statusModalEntityViewerMovimenti} />
            )}

        </>
    )
};